import { useParams } from 'react-router-dom';
import { ItemCreationForm } from './ItemCreatorForm';

export function ItemCreatorEditFormWrapper() {
    const { id } = useParams();

    return (
        <ItemCreationForm editItemListingId={id} />
    );
}